const burgerMenuBtn = document.querySelector('.hamburger-menu');

const burgerMenu = document.querySelector('.header-popup');
const headerCategories = document.querySelector('.header-categories');
// Guard: some pages render without the hamburger menu / header-categories.
// Without this, querySelector(...) is null and the whole module throws here,
// killing every handler defined further down (including the mobile subnav popup).
const headerCategoriesListBtns = headerCategories
  ? headerCategories.querySelectorAll('.header-categories__mainItem-btn')
  : [];

if (burgerMenuBtn && burgerMenu) {
  burgerMenuBtn.addEventListener('click', () => {
    burgerMenuBtn.classList.toggle('hamburger-menu_active');
    burgerMenu.classList.toggle('header-popup_active');
    document.body.classList.toggle('body-lock');
  });
}
console.log("ssssssssssssss")
// Toggle header categories
headerCategoriesListBtns.forEach((el) => {
  el.addEventListener('click', () => {
    const headerCategoriesList = el.parentElement.parentElement;
    const submenu = headerCategoriesList.querySelector('.header-categories__submenu');
    console.log(submenu);
    if (headerCategoriesList.classList.contains('header-categories__item_active')) {
      // Collapse
      submenu.style.height = '0';
    } else {
      // Expand
      submenu.style.height = 'auto';
      const height = submenu.scrollHeight;
      submenu.style.height = '0';
      // Force a reflow
      submenu.offsetHeight;
      submenu.style.height = `${height}px`;
    }

    headerCategoriesList.classList.toggle('header-categories__item_active');
  });
});

// ── Mobile subnav subcategory popup ─────────────────────────────
  // The mobile subnav is a horizontal overflow:auto scroller, so an absolute
  // popup would be clipped. On tap we place the popup with position:fixed (coords
  // computed from the item, see header.scss) and toggle it open. First tap on a
  // parent opens its popup; a second tap follows the parent link. Subcategory
  // links inside the popup navigate normally.
  //
  // Uses document-level delegation so it works regardless of when the subnav is
  // rendered and never leaves stale per-node listeners behind.
  (() => {
    const OPEN = 'nav__item-submenu_open';
    const mq = window.matchMedia('(max-width: 1024px)');

    const submenusIn = (root) =>
      (root || document).querySelectorAll('.header-mobile-subnav .nav__item-submenu');

    const closeAll = () => {
      submenusIn().forEach((it) => {
        it.classList.remove(OPEN);
        const sub = it.querySelector('.nav__submenu');
        if (sub) {
          sub.style.left = '';
          sub.style.top = '';
        }
      });
    };

    const openItem = (item) => {
      const submenu = item.querySelector('.nav__submenu');
      if (!submenu) return;
      closeAll();
      item.classList.add(OPEN);
      const rect = item.getBoundingClientRect();
      const maxLeft = window.innerWidth - submenu.offsetWidth - 8;
      submenu.style.left = `${Math.max(8, Math.min(rect.left, maxLeft))}px`;
      submenu.style.top = `${rect.bottom}px`;
    };

    // Capture phase: fires top-down before any bubble-phase stopPropagation on
    // intermediate nodes can swallow the click.
    document.addEventListener(
      'click',
      (e) => {
        // Tap on a parent link inside the mobile subnav → reveal its popup.
        const parentLink = e.target.closest('.header-mobile-subnav .nav__item-submenu > a');
        if (parentLink && mq.matches) {
          const item = parentLink.parentElement;
          if (!item.classList.contains(OPEN)) {
            e.preventDefault(); // first tap reveals; second tap follows the link
            openItem(item);
          }
          return; // already open → let the link navigate
        }
        // Tap anywhere else (outside an open item) closes.
        if (!e.target.closest('.header-mobile-subnav .nav__item-submenu')) closeAll();
      },
      true,
    );

    document.addEventListener(
      'scroll',
      (e) => {
        if (e.target.closest && e.target.closest('.header-mobile-subnav__container')) closeAll();
      },
      true,
    );
    window.addEventListener('resize', closeAll);
  })();

const searchInputs = document.querySelectorAll('.search input');

searchInputs.forEach(input => {
  input.addEventListener('focus', () => {
    input.closest('.search').classList.add('search_focused');
    input.classList.add('search__input_focused');
  });

  input.addEventListener('blur', () => {
    input.closest('.search').classList.remove('search_focused');
    input.classList.remove('search__input_focused');
  });
});
